import { render, staticRenderFns } from "./Tag3.vue?vue&type=template&id=59c631cf&scoped=true"
import script from "./Tag3.vue?vue&type=script&lang=js"
export * from "./Tag3.vue?vue&type=script&lang=js"
import style0 from "./Tag3.vue?vue&type=style&index=0&id=59c631cf&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c631cf",
  null
  
)

export default component.exports